import { Component, Input, OnInit } from "@angular/core";
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from "@ptl/account-management";
import { RedirectService } from "src/app/angular-elements/shared/services/redirect.service";
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-sales-force-test-sso',
    templateUrl: './sales-force-test-sso.component.html',
    styleUrls: ['./sales-force-test-sso.component.scss'],
    standalone: false
})
export class SalesForceTestSsoComponent {

  /**
   * THIS COMPONENT IS NOT CURRENTLY USED. CONFIRM AND REMOVE WHEN POSSIBLE
   */

  @Input() label;
  @Input() lob: LINE_OF_BUSINESS_ENUM;
    
  userId = '';
  isSalesForceInternal = false;
  isSalesForceExternal = false;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private redirectService: RedirectService,
    private entitlementHelper: EntitlementsHelperService
  ) { }

  async ngOnInit() {
    if (!this.lob) {
      this.lob = await this.entitlementHelper.getCurrentLobPromise();
    }

    this.isSalesForceInternal = this.entitlementHelper.entitlementValueByNameAndLob(ENTITLEMENTS.SALES_FORCE_INTERNAL, this.lob);
    this.isSalesForceExternal = this.entitlementHelper.entitlementValueByNameAndLob(ENTITLEMENTS.SALES_FORCE_EXTERNAL, this.lob);

    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    this.userId = loginInfo.userId;
  }
  
  submitForm() {
    let destinationURL = 'SFHCTRNBROKER';
    
    let target = "https://" + environment.external.vendors.agentCubeUrl;
    let postParams = { userName: this.userId, destinationURL: destinationURL, target }
    this.redirectService.post(postParams);
  }
}
